module.exports = __webpack_public_path__ + "img/Vector.368726fb.svg";